import ExistingIdsListNextPageLoader from './ExistingIdsListNextPageLoader';

export default class InternalMemoryNextPageLoader<T> extends ExistingIdsListNextPageLoader<T, T> {
  constructor(allItems: T[], pageSize: number, filterer: ((item: T) => boolean) | null) {
    super(allItems, pageSize, filterer, async (t) => t);
  }
}
